import React, { useEffect, useState } from "react"
import VistaprintAuth from "@vp/auth"
import pricingContextModuleHelpers from "@vp/pricing-context-module/helpers"
import { Header, Footer, BOOKEND_TYPES } from "@vp/esi-bookends"
import { BoundedContent, Box, MainContentStart, SiteContent, SiteMain } from "@vp/swan"
import { SwanConfiguration } from "../components/SwanConfiguration"

import { buildAnalyticsMetaData, PAGE_STAGE } from "../utils/tracking"

const Layout = (props) => {
  const [authLibrary, setAuthLibrary] = useState(null)
  const country = props.pageContext.node_locale.split(/-|_/)[1].toUpperCase()

  useEffect(() => {
    const initPricingContext = () => {
      const isAuthInitialized = !!authLibrary
      if (isAuthInitialized) {
        pricingContextModuleHelpers.initializePricingContext(
          {
            merchantId: process.env.GATSBY_TENANT,
            market: country,
            isDevelopmentMode: process.env.GATSBY_DEVELOPMENT_MODE || process.env.NODE_ENV === "development",
          },
          () => {}
        )
      }
    }
    initPricingContext()
  }, [authLibrary, country])

  useEffect(() => {
    const config = {
      culture: props.pageContext.node_locale,
    }
    if (process.env.GATSBY_AUTH_CONNECTION) {
      config.options = {
        connection: process.env.GATSBY_AUTH_CONNECTION,
      }
    }
    if (process.env.GATSBY_AUTH_DEVELOPMENT_MODE_CLIENT_ID) {
      config.developmentMode = {
        clientID: process.env.GATSBY_AUTH_DEVELOPMENT_MODE_CLIENT_ID,
        redirectUriOrigin: process.env.GATSBY_AUTH_CALLBACK_URL ? process.env.GATSBY_AUTH_CALLBACK_URL : window.location.origin,
      }
    } else {
      config.developmentMode = process.env.GATSBY_DEVELOPMENT_MODE ? true : false
    }

    VistaprintAuth.init(config, () => {
      const authLibraryInstance = new VistaprintAuth.WebAuth()
      setAuthLibrary(authLibraryInstance)
    })
  }, [props.pageContext.tenant, props.pageContext.node_locale])
  return (
    <SwanConfiguration tenant={props.pageContext.tenant} locale={props.pageContext.node_locale}>
      <SiteContent>
        <Header
          locale={props.pageContext.node_locale}
          tenant={props.pageContext.tenant}
          type={BOOKEND_TYPES.FULL}
          hideSearch={false}
          hideVat={false}
          trackingConfiguration={buildAnalyticsMetaData(props.trackingData)}
        />
        <SiteMain>
          <MainContentStart />
          <Box pt={"5"} pb={"7"}>
            <BoundedContent>{props.children}</BoundedContent>
          </Box>
        </SiteMain>
        <Footer
          locale={props.pageContext.node_locale}
          tenant={props.pageContext.tenant}
          type={BOOKEND_TYPES.FULL}
          trackingConfiguration={buildAnalyticsMetaData(props.trackingData)}
        />
      </SiteContent>
    </SwanConfiguration>
  )
}

export default Layout
